import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Wrapper from '../components/wrapper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import SettingList from '../components/setting-list'
import { LogoGa } from '../components/app-icon/Icons'
import FullScreenDialog from '../components/app-dialog'
import DataSetForm from '../components/app-form/DataSetForm'
import { ButtonOutlined } from '../components/app-button/button'
import CustomizeAll from '../components/сustomize-all/'
import LicenseExpired from '../components/payment/LicenseExpired'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import Typography from '@material-ui/core/Typography'
import TraficLight from '../components/traficLight'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 630,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '0 40px 30px 22px',
  },

  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 14px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
})

class DataSet2 extends Component {
  state = {
    isFetching: false,
    site: window.state.site,
    client: window.state.google_analytics_client,
    accounts: window.state.google_analytics_accounts,
    datasets: window.state.google_analytics_datasets,
    errorMessage: window.state.errorMessage,
    isCard: window.state.cardTest,
  }

  render() {
    const { classes } = this.props
    const {
      site,
      client,
      accounts,
      datasets,
      errorMessage,
      isCard,
    } = this.state

    return (
      <Fragment>
        <LicenseExpired>
          <ActionsForUsing />
        </LicenseExpired>
        <div className={classes.pageTemplate}>
          <AppBar
              position="static"
              color="inherit"
              elevation={0}
              style={{ padding: '24px' }}
            >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              <TraficLight />
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <Wrapper shadow={4}>
                <header className={classes.header}>
                  <LogoGa className={classes.logoGa} />
                </header>

                <section className={classes.content}>
                  <SettingList
                    {...client}
                    accounts={accounts}
                    prevUrl={'/ga/settings'}
                  />

                  {datasets && datasets.length ? (
                    <Dataset_ok
                      onSubmit={this.handleSubmit}
                      datasets={this.state.datasets}
                    />
                  ) : null}

                  {!datasets.length && errorMessage ? (
                    <Dataset_error
                      classes={classes}
                      errorMessage={errorMessage}
                    />
                  ) : null}

                  {!datasets.length && !errorMessage ? (
                    <Dataset_no classes={classes} />
                  ) : null}
                </section>
              </Wrapper>
            </div>
          </div>
        </div>
      </Fragment>
      )
  }
}

const Dataset_no = ({ classes }) => (
  <React.Fragment>
    <Typography gutterBottom>
      Для окончания настройки GA для выбранного ресурса нужно добавить набор
      данных, в который будут экспортироваться затраты из рекламных сервисов.
    </Typography>
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 600, fontSize: 14 }}
      gutterBottom
    >
      В вашем аккаунте набор данных не найден!
    </Typography>
    <Typography gutterBottom>
      Добавьте набор данных в Google Analytics, вернитесь на эту страницу и
      завершите настройку.
    </Typography>
    <ul className={classes.list}>
      <li className={classes.item}>
        <FullScreenDialog />
      </li>
    </ul>
    <ButtonOutlined
      style={{
        marginTop: 16,
      }}
      full={true}
      href={window.location.href}
      color="secondary"
      text="Проверить набор данных"
    />
  </React.Fragment>
)

const Dataset_error = ({ classes, errorMessage }) => (
  <React.Fragment>
    <Typography gutterBottom>
      Для окончания настройки GA для выбранного ресурса нужно добавить набор
      данных, в который будут экспортироваться затраты из рекламных сервисов.
    </Typography>
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 600, fontSize: 14, color: 'red' }}
      gutterBottom
    >
      {errorMessage}
    </Typography>
  </React.Fragment>
)

class Dataset_ok extends Component {
  state = {
    datasets: window.state.google_analytics_datasets,
  }

  redirect = (nextUrl, status) => {
    if (status === 'ok') {
      location.href = nextUrl
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/ga/dataset'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(({ nextUrl, status }) => {
        this.timerId = setTimeout(() => this.redirect(nextUrl, status), 1000)
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  componentWillUnmount() {
    clearTimeout(this.timerId)
  }

  render() {
    const { datasets } = this.state
    const datasetsItem = datasets.filter(dataset => dataset.selected)

    return (
      <React.Fragment>
        <Typography variant="body2" paragraph>
          В этот “набор данных” будут экспортироваться данные о затратах из
          рекламных сервисов.
        </Typography>

        <DataSetForm
          isFetching={this.state.isFetching}
          onSubmit={this.handleSubmit}
          datasetsItem={datasetsItem}
          datasets={datasets}
          initialValues={
            !!(datasetsItem && datasetsItem.length)
              ? {
                  dataset: datasetsItem[0].id,
                }
              : null
          }
        />
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(DataSet2)
